import "./projects.scss";
import api from "api";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { actions } from "redux/reducers";
import { ProjectType, RootState } from "types";
import ProjectSection from "components/app/projects/project-section";

function Projects() {
    const params: any = useParams();
    const dispatch = useDispatch();
    const state = useSelector((state: RootState) => state);
    const [showOptionsModal, setShowOptionsModal] = useState(false);
    const [optionsModalName, setOptionsModalName] = useState<string>("");
    const [optionsModalId, setOptionsModalId] = useState<number>(0);
    const user = useSelector((state: RootState) => state.user);
    const history = useHistory();

    const getProjects = useCallback(() => {
        api.project.getAll(params.clientId).then((data: ProjectType[]) => {
            const projectIds = Array.from(new Set(data.map((x: ProjectType) => x.Id)));
            let arr = [];
            for (let id of projectIds) {
                const project = data.find((x: ProjectType) => x.Id === id);
                let streamIds;
                if (project && project.ProjectTypeId !== (2 || 8)) {
                    streamIds = Array.from(new Set(data.filter((x: ProjectType) => x.Id === id && x.StreamId !== 11).map((x: ProjectType) => x.StreamId)));
                } else {
                    streamIds = Array.from(new Set(data.filter((x: ProjectType) => x.Id === id).map((x: ProjectType) => x.StreamId)));
                }
                arr.push({
                    ...project,
                    StreamId: streamIds.join(","),
                });
            }
            dispatch(actions.projects.set(arr));
        });
    }, [params.clientId, dispatch]);

    const newProject = () => {
        history.push(`/client/${params.clientId}/new-project`);
    };

    const updateProjectName = async () => {
        await api.project.updateProjectName(optionsModalId, optionsModalName);
        getProjects();
        CloseOptionModal();
    };

    const deleteProject = () => {
        if (window.confirm("Are you sure you want to delete " + optionsModalName)) {
            api.project.deleteProject(optionsModalId, parseInt(params.clientId)).then(() => {
                getProjects();
                CloseOptionModal();
            });
        }
    };

    const OptionsModal = (id: number, projectName: string) => {
        setOptionsModalId(id);
        setOptionsModalName(projectName);
        setShowOptionsModal(true);
    };

    const CloseOptionModal = () => {
        setOptionsModalId(0);
        setOptionsModalName("");
        setShowOptionsModal(false);
    };

    useEffect(() => {
        getProjects();
    }, [getProjects]);

    useEffect(() => {
        dispatch(actions.projects.set(null));
    }, []);

    return (
        <>
            <div className="projects">
                <div className="top">
                    Projects
                    {user.IsAdmin === true && <button onClick={newProject}>New</button>}
                </div>
                <div className="body">
                    {state.projects &&
                        Array.from(new Set(state.projects.map((x: ProjectType) => x.ProjectType))).map((x, i) => (
                            <ProjectSection openOptionsModal={OptionsModal} heading={x} projects={state.projects.filter((y) => y.ProjectType === x)} key={i} />
                        ))}
                </div>
            </div>
            <div className={`optionsModal${showOptionsModal ? " open" : ""}`}>
                <div className="close-modal" onClick={() => CloseOptionModal()}>
                    <i className="fal fa-times" aria-hidden="true"></i>
                </div>
                <div className="modal-body">
                    <div className="contact-us">
                        <div className="input-group">
                            <label>Project name</label>
                            <input type="text" value={optionsModalName} onChange={(event) => setOptionsModalName(event.currentTarget.value)} />
                        </div>
                        <button onClick={updateProjectName}>Update</button>
                        <button className="delete-button" onClick={deleteProject}>
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Projects;
